import {
  filterByCellValueMenuItem,
  useDynamicCallback,
  useJsonModal,
  useMixpanel,
  type AgGridMenuItems,
  type Column,
  type ColumnDef,
  type FilterableProperty,
  type ITradeAllocation,
  type UseFilterBuilderOutput,
} from '@talos/kyoko';
import type { GetContextMenuItemsParams } from 'ag-grid-community';
import { useMemo } from 'react';
import { TradeAllocationMenu } from './TradeAllocationMenu';
import { colIDToFilterBuilderKey } from './useTradeAllocationFilter';

export function useTradeAllocationMenu({
  openClause,
  filterableProperties,
}: {
  openClause: UseFilterBuilderOutput['addAndOpenClause'];
  filterableProperties: FilterableProperty<string>[];
}): {
  getCustomContextMenuItems: (params: GetContextMenuItemsParams) => AgGridMenuItems;
  dialogs: JSX.Element;
  column: Column;
} {
  const mixpanel = useMixpanel();
  const { handleClickJson, jsonModal } = useJsonModal();

  const dialogs = useMemo(() => <>{jsonModal}</>, [jsonModal]);

  const column = useMemo<Column>(
    () =>
      ({
        type: 'hamburgerMenu',
        id: 'marketExecutionReportMenu',
        params: {
          renderItems: params => <TradeAllocationMenu {...params} onShowJson={handleClickJson} />,
          csvExport: true,
        },
      }) satisfies ColumnDef<ITradeAllocation>,
    [handleClickJson]
  );

  const getCustomContextMenuItems = useDynamicCallback((params: GetContextMenuItemsParams) => {
    if (params?.node?.data == null) {
      return [];
    }
    return filterByCellValueMenuItem({
      params,
      filterableProperties,
      openClause,
      colIDToFilterBuilderKey,
      mixpanel,
    });
  });

  return { column, getCustomContextMenuItems, dialogs };
}
